import AcceptInvite from "./AcceptInvite";
export default AcceptInvite;
